export function parseOracleErrorMessage(errOrText) {
  try {
    let raw = "";

    if (typeof errOrText === "string") {
      raw = errOrText;
    } else if (errOrText && typeof errOrText === "object") {
      const resp = errOrText.response || {};
      const data = resp.data;
      if (typeof data === "string") {
        raw = data;
      } else if (data && typeof data === "object") {
        raw = data.message || data.error || "";
      } else {
        raw = errOrText.message || "";
      }
    }

    if (!raw || typeof raw !== "string") {
      return "Ha ocurrido un error en la solicitud. Verifique los datos e intente nuevamente.";
    }
    const normalized = raw.replace(/\\n/g, "\n");

    const match20001 = normalized.match(/ORA-20001:\s*([\s\S]*?)(?:\n|$|ORA-\d+|\\|\/)/);
    if (match20001 && match20001[1]) {
      return match20001[1].trim();
    }
    const matchGeneric = normalized.match(/ORA-\d+:\s*([\s\S]*?)(?:\n|$|ORA-\d+|\\|\/)/);
    if (matchGeneric && matchGeneric[1]) {
      return matchGeneric[1].trim();
    }
    return normalized.trim() || "Ha ocurrido un error en la solicitud. Verifique los datos e intente nuevamente.";
  } catch (_) {
    return "Ha ocurrido un error en la solicitud. Verifique los datos e intente nuevamente.";
  }
}